<template>
  <v-dialog ref="confirm" v-model="dialog" :max-width="options.width" :style="{ zIndex: options.zIndex }" @keydown.esc="handle(false)" @keydown.enter="handle(true)">
    <v-card>
      <v-toolbar dark :color="options.color" dense flat>
        <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text v-show="!!message" class="pa-4">
        {{ message }}
        <v-text-field
          v-if="options.promptLabel"
          :label="options.promptLabel"
          v-model="input"
          hide-details
        />
        <v-checkbox
          v-if="options.checkbox"
          v-for="(checkbox, index) of options.checkbox"
          :key="'confirm-checkbox-' + index"
          :label="checkbox.text"
          v-model="checkbox.value"
          hide-details
        />

      </v-card-text>
      <v-card-actions class="pt-0 px-0">
        <v-spacer></v-spacer>
        <v-btn v-for="(button, index) in options.buttons" :key="'confirm-dialog-' + index" :color="button.class || 'grey'" text @click.native="handle(button.value)">{{ button.text }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  /**
   * Vuetify Confirm Dialog component
   *
   * Insert component where you want to use it:
   * <confirm ref="confirm"></confirm>
   *
   * Call it:
   * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {})
   * Or use await:
   * if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
   *   // yes
   * }
   * else {
   *   // cancel
   * }
   *
   * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
   * <template>
   *   <v-app>
   *     ...
   *     <confirm ref="confirm"></confirm>
   *   </v-app>
   * </template>
   *
   * mounted() {
   *   this.$root.$confirm = this.$refs.confirm.open
   * }
   */

  import { cloneDeep } from 'lodash'

  export default {
    data: () => ({
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      input: '',
      options: {},
      defaultOptions: {
        color: 'primary',
        width: 290,
        zIndex: 200,
        buttons: [
          { text: 'Yes', value: true, class: 'primary darken-1' },
          { text: 'Cancel', value: false, class: 'grey' },
        ]
      }
    }),
    watch: {
      dialog(val) {
        if(!val) this.handle(false)
      }
    },
    methods: {
      open (title, message, options) {
        if(!options) options = {}

        this.dialog = true
        this.title = title
        this.message = message
        this.input = options.prompt || ''
        this.options = Object.assign(cloneDeep(this.defaultOptions), options)
        return new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
        })
      },
      handle (value) {
        if (value && this.input) {
          this.resolve(this.input)
        } else {
          this.resolve(value)
        }
        this.dialog = false
      },
      key_enter (value) {
        if (value === true) {
          this.handle(value)
        }
      }
    }
  }
</script>
